import * as e from "react";
import { forwardRef as l } from "react";
const a = l(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.105 7.11L9.81 3.405V0L3.75 6.06V16.035L6.105 13.68V7.11Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.17 8.97005L14.835 4.30505V0.675049L7.65002 7.86005V19.935L10.17 17.415V8.97005Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.175 1.33496L11.715 9.77996V24L20.175 15.555V1.33496Z",
        fill: "currentColor"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement(
      "rect",
      {
        fill: "currentColor",
        height: 24,
        transform: "translate(3.75)",
        width: 16.425
      }
    )))
  );
});
export {
  a as BetBuilder
};
